module.exports = __webpack_public_path__ + "img/chevron-right.fd8c423c.svg";